import { BaseContract } from '../common/base.contract';
import {Contract, ethers, JsonRpcProvider} from 'ethers';
import RoundFacetAbi from '../../abi/Facets/RoundFacet.json';
import { RoundStakingStatus } from '../../model/staking.model';
import { mapRound } from '../../mappers/round.mapper';
import { Round } from '../../model/round.model';
import { log } from 'console';


export class RoundFacet extends BaseContract {
    constructor(address: string, provider: JsonRpcProvider) {
        super(new Contract(address, RoundFacetAbi.abi, provider));
    }

    getRoundDetails = async (roundId: string): Promise<Round> => {
        const data = await this.contract.getRoundDetails(roundId);
        return mapRound(data);
    }

    getRoundStatus = async (roundId: string): Promise<RoundStakingStatus> => {
        return await this.contract.getRoundStatus(roundId);
    }

    getStakingId = async (roundId: string): Promise<string> => {
        return await this.contract.getStakingId(roundId);
    }

    doBuyTokens = async (roundId: string, amount: number) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.doBuyTokens(roundId, amount);
        await tx.wait();
    }
} 
